<template>
  <el-dialog
    title="设置新密码"
    :visible.sync="innerVisible"
    width="560px"
    custom-class="pw-dialog"
    @close="onClose"
    @closed="handleDialogClosed"
  >
    <!-- 人员信息 -->
    <div class="pw-info">
      <div class="pw-info__row">
        <span class="pw-info__label">门店名称</span>
        <span class="pw-info__value">{{ row.storeName || '-' }}</span>
      </div>
      <div class="pw-info__row">
        <span class="pw-info__label">角色 / 姓名</span>
        <span class="pw-info__value">{{ row.employeeTypeName || '-' }} / {{ row.employeeName || '-' }}</span>
      </div>
      <div class="pw-info__row">
        <span class="pw-info__label">手机号</span>
        <span class="pw-info__value">{{ row.mobile || '-' }}</span>
      </div>
      <div class="pw-info__row">
        <span class="pw-info__label">当前密码状态</span>
        <span class="pw-info__value">{{ row.hasPassword ? '正常' : '未设置' }}</span>
      </div>
    </div>

    <!-- 密码输入：只读，只能由后端「随机生成」填充，故前端无需格式校验，仅校验非空 -->
    <el-form ref="pwForm" :model="pwForm" :rules="pwRules" label-position="top">
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model="pwForm.password"
          class="pw-input"
          placeholder="请点击随机生成"
          readonly
          @keyup.enter.native="handleSubmitPassword"
        >
          <el-link
            v-if="pwForm.password"
            slot="suffix"
            type="primary"
            :underline="false"
            @click="handleCopyPassword"
            >复制密码</el-link
          >
          <el-button slot="append" type="primary" :loading="generateLoading" @click="handleGeneratePassword" style="width:120px;"
            >随机生成</el-button
          >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="pw-warning">
      <i class="el-icon-warning-outline"></i>
      <span>新密码设置后立即生效，原密码失效。请通过安全渠道告知老板/员工本人妥善保管密码。</span>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmitPassword">确认修改</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { setPasswordAPI, generatePasswordAPI } from '../api';

export default {
  name: 'SetPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 当前员工行数据
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      innerVisible: false,
      submitLoading: false,
      generateLoading: false,
      pwForm: {
        id: '',
        password: ''
      },
      pwRules: {
        password: [{ required: true, message: '请先点击随机生成密码', trigger: 'blur' }]
      }
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.pwForm = { id: this.row.id, password: '' };
          this.$nextTick(() => {
            this.$refs.pwForm && this.$refs.pwForm.clearValidate();
          });
        }
      }
    }
  },
  methods: {
    // 随机生成密码：调后端接口生成
    handleGeneratePassword() {
      this.generateLoading = true;
      generatePasswordAPI()
        .then(res => {
          this.pwForm.password = (res && res.password) || '';
          this.$refs.pwForm && this.$refs.pwForm.clearValidate('password');
        })
        .finally(() => {
          this.generateLoading = false;
        });
    },
    // 复制密码
    handleCopyPassword() {
      this.$copyText(this.pwForm.password).then(() => {
        this.$message.success('密码已复制');
      });
    },
    // 确认修改
    handleSubmitPassword() {
      this.$refs.pwForm.validate(valid => {
        if (!valid) return;
        this.submitLoading = true;
        setPasswordAPI({ id: this.pwForm.id, password: this.pwForm.password })
          .then(() => {
            this.$message.success('密码设置成功');
            this.innerVisible = false;
            this.$emit('success');
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    // 关闭后重置表单状态
    handleDialogClosed() {
      this.$refs.pwForm && this.$refs.pwForm.resetFields();
      this.submitLoading = false;
    },
    onClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.pw-info {
  background: #f7f8fa;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;

  .pw-info__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 32px;
    font-size: 15px;
  }

  .pw-info__label {
    color: #909399;
    font-size: 15px;
  }

  .pw-info__value {
    color: #303133;
    font-weight: 500;
    font-size: 15px;
  }
}

.pw-warning {
  display: flex;
  align-items: flex-start;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
  color: #606266;
  line-height: 20px;

  i {
    color: #1890ff;
    margin-right: 6px;
    margin-top: 4px;
  }
}

// 弹框字号整体调大
::v-deep .pw-dialog {
  .el-dialog__title {
    font-size: 18px;
  }
  .el-dialog__body {
    font-size: 15px;
  }
  .el-form-item__label {
    font-size: 15px;
  }
  .el-input__inner {
    font-size: 15px;
  }
  .dialog-footer .el-button {
    font-size: 14px;
  }
}

// 随机生成按钮样式优化
::v-deep .el-input-group__append {
  background: #409eff;
  border-color: #409eff;

  .el-button {
    color: #fff;
  }
}

// 复制密码 suffix 上下居中 + 可点击
::v-deep .pw-input .el-input__suffix {
  display: flex;
  align-items: center;

  .el-link {
    pointer-events: auto;
  }
}

// 响应式：小屏适配
@media screen and (max-width: 768px) {
  ::v-deep .pw-dialog {
    width: 94vw !important;
  }
}
</style>
